import { type FC } from "react";

interface GxUploadFileUploadBtnProps {
  onClick?: () => void;
  disabled?: boolean;
  label?: string;
}

const GxUploadFileUploadBtn: FC<GxUploadFileUploadBtnProps> = ({
  onClick,
  disabled = false,
  label = "Upload",
}) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className="gx-upload-file-upload-btn gx-p16-b"
    >
      {label}
    </button>
  );
};

export default GxUploadFileUploadBtn;
